import React from 'react';
import { DeleteOutline } from '@mui/icons-material';
import { common, grey } from '@mui/material/colors';
import { CurrencyInputField } from 'components/form';
import { Column } from 'components/shared/TableListing/types';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { MarkupCell } from './cells/MarkupCell';
import { RateFactorCell } from './cells/RateFactorCell';
import { RetailPriceCell } from './cells/RetailPriceCell';
import { ProductConfig, ProductConfigListingContext } from '../../../types';

export const configurationListingColumns: Column<ProductConfig, ProductConfigListingContext>[] = [
  {
    header: 'Configuration',
    renderKey: 'configuration',
    width: '8rem',
    fixed: 'left',
    headerStyles: {
      backgroundColor: grey[300],
    },
    bodyStyles: {
      backgroundColor: common.white,
    },
    footerStyles: {
      backgroundColor: common.white,
    },
    renderCell: ({ rowIndex, context: { handleRemoveRow } }) => (
      <Stack direction="row" alignItems="flex-start" height="100%">
        <Stack direction="row" alignItems="center">
          <Tooltip title="Remove configuration">
            <IconButton size="small" color="error" onClick={() => handleRemoveRow(rowIndex)}>
              <DeleteOutline />
            </IconButton>
          </Tooltip>

          <Typography>#{rowIndex + 1}</Typography>
        </Stack>
      </Stack>
    ),
  },
  {
    header: 'Cost',
    renderKey: 'cost',
    renderCell: ({ rowIndex }) => <RateFactorCell rowIndex={rowIndex} />,
  },
  {
    header: 'Markup',
    renderKey: 'markup',
    renderCell: ({ rowIndex }) => <MarkupCell rowIndex={rowIndex} />,
  },
  {
    header: 'Pricing',
    renderKey: 'pricing',
    renderCell: ({ rowIndex, context: { form } }) => (
      <Stack gap="0.5rem">
        <CurrencyInputField
          label="Min"
          control={form.control}
          textFieldProps={{ variant: 'outlined' }}
          name={`bodyFields.${rowIndex}.pricing.min`}
        />
        <CurrencyInputField
          label="Max"
          control={form.control}
          textFieldProps={{ variant: 'outlined' }}
          name={`bodyFields.${rowIndex}.pricing.max`}
        />
      </Stack>
    ),
  },
  {
    header: 'Retail Price',
    renderKey: 'retailPrice',
    width: '10rem',
    renderCell: ({ rowIndex }) => <RetailPriceCell rowIndex={rowIndex} />,
  },
];
